import axiosInstance from './config/api';
import { UserRoleType } from 'types/userRoles';

export interface PostLoginResponse {
    tenantId: string;
    token: string;
    userRole: UserRoleType[];
}

export const postLogin = async (idToken: string) => {
    return axiosInstance
        .post('/auth/login', {}, { headers: { Authorization: `Bearer ${idToken}` } })
        .then((res) => res.data);
};
